import { useState } from "react"
import Box from "@mui/material/Box"
import Tooltip from "@mui/material/Tooltip"
import LinkIcon from "@mui/icons-material/Link"

export function VaultLinkChip({ path, label, onVaultLink }) {
  const [preview, setPreview] = useState("")
  const [loaded, setLoaded] = useState(false)

  const handleHover = () => {
    if (loaded) return
    setLoaded(true)
    fetch(`/api/vault/file/?path=${encodeURIComponent(path)}`)
      .then(r => r.json())
      .then(d => {
        const content = d.content || ""
        const lines = content.split("\n").filter(l => l.trim() && !l.startsWith("#"))
        setPreview(lines.slice(0, 3).join(" ").slice(0, 200))
      })
      .catch(() => setPreview("Vorschau nicht verfügbar"))
  }

  return (
    <Tooltip title={preview || "Lade Vorschau…"} placement="top" arrow onOpen={handleHover}>
      <Box component="span"
        onClick={onVaultLink ? (e) => { e.stopPropagation(); onVaultLink(path) } : undefined}
        sx={{ color: "var(--feature-vault)", fontStyle: "italic", display: "inline-flex", alignItems: "center", gap: "2px",
          cursor: onVaultLink ? "pointer" : "default",
          "&:hover": onVaultLink ? { opacity: 0.75, textDecoration: "underline" } : {} }}>
        <LinkIcon sx={{ fontSize: 11, verticalAlign: "middle" }} />{label}
      </Box>
    </Tooltip>
  )
}
